import axios from 'axios';

import {
  LOGIN_FAILURE,
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  SIGNOUT,
  SIGNUP_FAILURE,
  SIGNUP_REQUEST,
  SIGNUP_SUCCESS,
} from './actionTypes';

import { setLocalItem } from '../helpers/localstorage';

export function loginFacebook(accessToken, callback1, callback2) {
  return dispatch => {
    dispatch({ type: LOGIN_REQUEST });

    return axios({
      url: `${process.env.GATSBY_API_URL}/auth/facebook-token`,
      method: 'post',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      data: {
        access_token: accessToken,
      },
    })
      .then(response => {
        dispatch({ type: LOGIN_SUCCESS, payload: response.data });
        if (typeof localStorage !== `undefined`) {
          setLocalItem('login', response.data);
        }
        callback1();
      })
      .catch(error => {
        dispatch({ type: LOGIN_FAILURE, payload: error });
        callback2();
        console.error(error);
      });
  };
}

export function signIn(email, pwd, callback1, callback2) {
  return dispatch => {
    dispatch({ type: LOGIN_REQUEST });

    return axios({
      url: `${process.env.GATSBY_API_URL}/auth/signIn`,
      method: 'post',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      data: {
        email: email,
        password: pwd,
      },
    })
      .then(response => {
        dispatch({ type: LOGIN_SUCCESS, payload: response.data });
        if (typeof localStorage !== `undefined`) {
          setLocalItem('login', response.data);
        }
        callback1();
      })
      .catch(error => {
        dispatch({ type: LOGIN_FAILURE, payload: error });
        callback2();
        console.error(error);
      });
  };
}

export function signUp(nom, prenom, phone, email, pwd, callback1, callback2) {
  return dispatch => {
    dispatch({ type: SIGNUP_REQUEST });

    return axios({
      url: `${process.env.GATSBY_API_URL}/auth/signUp`,
      method: 'post',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      data: {
        firstName: nom,
        lastName: prenom,
        phone: phone,
        method: 'local',
        local: {
          email: email,
          password: pwd,
        },
      },
    })
      .then(response => {
        dispatch({ type: SIGNUP_SUCCESS, payload: response.data });
        if (typeof localStorage !== `undefined`) {
          setLocalItem('login', response.data);
        }
        callback1();
      })
      .catch(error => {
        dispatch({ type: SIGNUP_FAILURE, payload: error });
        callback2();
        console.error(error);
      });
  };
}

export const logout = () => dispatch => {
  dispatch({ type: SIGNOUT });
  if (typeof localStorage !== `undefined`) {
    localStorage.removeItem('login');
  }
};



// WEBPACK FOOTER //
// ./src/actions/loginAction.js